import { useState } from 'react';
import { useDispatch } from 'react-redux';

import { auditLogActions } from '../data-store';
import useAuditLogData from '../hooks/useAuditLogData';

/**
 * Custom hook to manage insights state
 * Handles Entitlement selection and navigation between list and details views
 */
export default function useInsightsState() {
  const dispatch = useDispatch();
  const { refreshAuditLogs } = useAuditLogData();
  const [selectedTCode, setSelectedTCode] = useState<string | null>(null);

  const handleTCodeClick = (codeId: string) => {
    setSelectedTCode(codeId);
    dispatch(auditLogActions.applyInsightFilter(codeId));
    window.dispatchEvent(new CustomEvent('scrollAuditLogListToTop'));
    // Trigger /search with the selected insight id
    refreshAuditLogs();
  };

  const handleBackToInsights = () => {
    setSelectedTCode(null);
    dispatch(auditLogActions.applyInsightFilter(null));
    window.dispatchEvent(new CustomEvent('scrollAuditLogListToTop'));
    // Trigger /search with empty insightIds
    refreshAuditLogs();
  };

  return {
    selectedTCode,
    handleTCodeClick,
    handleBackToInsights,
  };
}
